export const APP_NAME = 'logo_maker_perseus';
export const STATSD_PREFIX = `services.${APP_NAME}`;
